<template>
  <div
    v-if="!isSkipModuleEnable"
    ref="readpeakContainer"
    class="dn-read-peak-ad"
  />
</template>
<script setup lang="ts">
import { ref } from 'vue';

const { skipModule, moduleNames } = useSkipModules(useRoute());
const isSkipModuleEnable = ref(skipModule(moduleNames.AD));
const readpeakContainer = ref(null);
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  numberOfAds: {
    type: Object,
    required: true
  },
  tags: {
    type: Array,
    default: () => [],
    required: false
  }
});

if (!isSkipModuleEnable.value) {
  useHead({
    script: [
      {
        src: 'https://static.readpeak.com/js/rp-int.js',
        async: true,
        id: 'readpeak-script'
      }
    ]
  });
}

onMounted(() => {
  if (!isSkipModuleEnable.value) {
    // Initialize Readpeak configuration
    const element = document.createElement('div');
    readpeakContainer.value.appendChild(element);
    window.__rpplc = window.__rpplc || [];
    window.__rpplc.push({
      id: props.id,
      width: 500,
      height: 435,
      gdpr_consent: useCookie('eupubconsent-v2').value,
      cats: [],
      tags: props?.tags || [],
      numberOfAds: props?.numberOfAds?.[getDeviceType()]
    }, element);
  }
});
</script>

<style scoped lang="scss">
.dn-read-peak-ad {
  &.full-width{
    grid-column: span 12;
  }
}
</style>
